// 📂 frontend/src/hooks/useToast.ts
import { useState, useCallback } from 'react';

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message: string;
  duration?: number;
}

export interface ToastMethods {
  success: (title: string, message: string, duration?: number) => void;
  error: (title: string, message: string, duration?: number) => void;
  info: (title: string, message: string, duration?: number) => void;
  warning: (title: string, message: string, duration?: number) => void;
}

export const useToast = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);
  
  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const toast: ToastMethods = {
    success: (title: string, message: string, duration = 7000) => {
      const id = Date.now().toString();
      setToasts(prev => [...prev, { id, type: 'success', title, message, duration }]);
      if (duration > 0) {
        setTimeout(() => removeToast(id), duration);
      }
    },
    error: (title: string, message: string, duration = 7000) => {
      const id = Date.now().toString();
      setToasts(prev => [...prev, { id, type: 'error', title, message, duration }]);
      if (duration > 0) {
        setTimeout(() => removeToast(id), duration);
      }
    },
    info: (title: string, message: string, duration = 7000) => {
      const id = Date.now().toString();
      setToasts(prev => [...prev, { id, type: 'info', title, message, duration }]);
      if (duration > 0) {
        setTimeout(() => removeToast(id), duration);
      }
    },
    warning: (title: string, message: string, duration = 7000) => {
      const id = Date.now().toString();
      setToasts(prev => [...prev, { id, type: 'warning', title, message, duration }]);
      if (duration > 0) {
        setTimeout(() => removeToast(id), duration);
      }
    }
  };

  return { toasts, toast, removeToast };
};